export interface Attachment {
  id: number;
  name: string;
  content: string;
}

// 附件的正文不在聊天气泡里展示：拼给模型/存进库的内容里仍然包含完整正文，
// 只是展示层把它折叠成一行提示，避免几千字的文件内容把对话刷屏。
export function attachmentBlock(a: Attachment): string {
  return `[${a.name}]\n${a.content}`;
}

export function composeSendText(typed: string, attachments: Attachment[]): string {
  return [typed, ...attachments.map(attachmentBlock)].filter((part) => part.trim()).join("\n\n");
}

// 历史消息是按上面 composeSendText 的格式存进库的，这里在展示时把 `[文件名]\n正文……`
// 拆回「输入的文字 + 附件名列表」，正文不进气泡，也不影响库里的原始内容。
export function splitStoredUserText(raw: string): { text: string; attachments: string[] } {
  const names: string[] = [];
  const text = raw
    .replace(/\[([^\n\]]+)\]\n[\s\S]*?(?=\n\n\[[^\n\]]+\]\n|$)/g, (_match, name: string) => {
      names.push(name);
      return "";
    })
    .trim();
  return { text, attachments: names };
}

export function chapterGeneratingLabel(title: string | undefined, revising: boolean): string {
  if (!title) return revising ? "正在修订中…" : "正在生成中…";
  return revising ? `正在按您的意见修订《${title}》…` : `正在生成《${title}》…`;
}

export function chapterDoneLabel(title: string | undefined, revising: boolean): string {
  const name = title ? `《${title}》` : "本章节";
  return revising
    ? `${name}已按您的意见更新，可在左侧「方案文档预览 / 批注」中查看最新版本。`
    : `${name}已生成完成，可在左侧「方案文档预览 / 批注」中查看。`;
}

export const ASSISTANT_HISTORY_PLACEHOLDER =
  "该轮回复已生成完成，相关正文已同步到方案文档，可在左侧「方案文档预览 / 批注」中查看。";
